/**
 * Nass Coach Gallery — arrows, dots and scroll sync for the "Meet Nastya"
 * photo slider (Body Transformation handoff: gaPrev/gaNext/gaDot/onGaScroll).
 * Dots map to fractions of the track's max scroll, same as the handoff.
 */
document.querySelectorAll('[data-nass-coach-gallery]').forEach((rail) => {
  const track = rail.querySelector('[data-nass-cg-track]');
  if (!track) return;
  const section = rail.closest('section');
  const dots = [...(section?.querySelectorAll('.nass-coach-gallery__dot') || [])];

  const cardStep = () => {
    const photo = track.querySelector('.nass-coach-gallery__photo');
    return photo ? photo.offsetWidth + 14 : 300;
  };

  rail.querySelector('[data-nass-cg-prev]')?.addEventListener('click', () => {
    track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
  });
  rail.querySelector('[data-nass-cg-next]')?.addEventListener('click', () => {
    track.scrollBy({ left: cardStep(), behavior: 'smooth' });
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const i = Number(dot.dataset.i) || 0;
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: (i / (dots.length - 1)) * max, behavior: 'smooth' });
    });
  });

  track.addEventListener(
    'scroll',
    () => {
      if (!dots.length) return;
      const max = track.scrollWidth - track.clientWidth;
      const idx = max > 0 ? Math.round((track.scrollLeft / max) * (dots.length - 1)) : 0;
      dots.forEach((d, i) => d.classList.toggle('nass-coach-gallery__dot--on', i === idx));
    },
    { passive: true }
  );
});
